/**
 * @internal
 */
var NumberingSystem = /** @class */ (function () {
    function NumberingSystem(name, symbols, minimumGroupingDigits, primaryGroupingSize, secondaryGroupingSize) {
        this.name = name;
        this.symbols = symbols;
        this.minimumGroupingDigits = minimumGroupingDigits;
        this.primaryGroupingSize = primaryGroupingSize;
        this.secondaryGroupingSize = secondaryGroupingSize;
    }
    return NumberingSystem;
}());
export { NumberingSystem };
